<template>
  <div class="authWrapper new-login-wrapper">
    <div class="container">
      <div class="row whiteBG-wrap login-white-wrap">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <router-link to="/login-password" class="ms-0 ps-0 login-highlight back-btn-pwd">Back</router-link>
            <div class="rep-icon-login">
              <img src="../../../assets/images/group-icon.svg" alt="image-fluid" />
            </div>
            <h4 class="login-title mb-2">Send OTP</h4>
            <div class="auth-form pt-3 pb-3">
              <!-- Phone Option -->
              <div class="verify-option mb-3" @click="selectOption('phone')" v-if="verifyIdentityInfo.phone">
                <div>
                  <label class="custom-radio">
                    <input type="radio" name="custom-radio" value="phone" v-model="option" />
                    <span class="radiomark"></span>
                  </label>
                </div>
                <div>Mobile ({{ verifyIdentityInfo.phone }})</div>
              </div>

              <!-- Email Option -->
              <div class="verify-option mb-3" @click="selectOption('email')" v-if="verifyIdentityInfo.email">
                <div>
                  <label class="custom-radio">
                    <input type="radio" name="custom-radio" value="email" v-model="option" />
                    <span class="radiomark"></span>
                  </label>
                </div>
                <div>Email ({{ verifyIdentityInfo.email }})</div>
              </div>

              <!-- Both Option -->
              <div class="verify-option mb-3" @click="selectOption('both')" v-if="verifyIdentityInfo.phone && verifyIdentityInfo.email">
                <div>
                  <label class="custom-radio">
                    <input type="radio" name="custom-radio" value="both" v-model="option" />
                    <span class="radiomark"></span>
                  </label>
                </div>
                <div>Email & Mobile</div>
              </div>

              <!-- Button -->
              <div>
                <button
                  :disabled="otpLoader"
                  class="submit-btn mt-3 next-btn"
                  type="button"
                  @click="sendOTP"
                >
                  <b-spinner v-if="otpLoader" small class="mr-3"></b-spinner>
                  Send Verification Code
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Carousel -->
        <div class="col-lg-5 col-md-5 no-padding">
          <Logincarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logincarsoule from "./Logincarsoule";
import axios from "axios";
import helper from "@/resource/Helper";

export default {
  name: "VerifyIdentity",
  components: {
    Logincarsoule,
  },
  data() {
    return {
      option: "", // 'phone' | 'email' | 'both'
      otpLoader: false,
      verifiedIdentitySelectedInfo: {},
    };
  },
  computed: {
    verifyIdentityInfo() {
      return this.$store.getters.groupInfoVerifyIdentity;
    },
  },
  mounted() {
    this.setDefaultVerifyIdentity();
  },
  methods: {
    setDefaultVerifyIdentity() {
      if (this.verifyIdentityInfo.phone && this.verifyIdentityInfo.email) {
        this.option = "email";
      } else if (this.verifyIdentityInfo.phone) {
        this.option = "phone";
      } else {
        this.option = "email";
      }
    },
    selectOption(value) {
      this.option = value;
    },
    sendOTP() {
      this.otpLoader = true;
      this.$store.commit("setAuthentication", false);

      const email = this.verifyIdentityInfo.email;
      const phone = this.verifyIdentityInfo.phone;
      const type = this.option;
      const device_id = this.$store.getters.deviceId || this.$uuid.v1();

      // Save device ID if not already set
      if (!this.$store.getters.deviceId) {
        this.$store.commit("setDeviceId", device_id);
      }
      if (!this.$store.getters.groupEmail) {
        this.$store.commit("setGroupEmail", this.email);
      }

      const payload = {
        type,
        device_id,
        email
      };

      this.verifiedIdentitySelectedInfo = payload;
      this.$store.dispatch("verifiedIdentitySelectedInfo", payload);

      const url = process.env.VUE_APP_API_URL_V3 + `auth/reset-generate-otp`;

      axios
        .post(url, payload)
        .then((response) => {
          this.otpLoader = false;
          if (response.data.status === "success") {
            this.$router.push("/verify-forgot-otp");
            helper.infoMessage(this, response.data.status, response.data.message);
          }
        })
        .catch((error) => {
          this.otpLoader = false;
          if (error.response?.data?.status === "error") {
            helper.infoMessage(this, error.response.data.status, error.response.data.message);
          }
        });
    },
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style>
#label-username,
#label-password {
  font-size: 16px !important;
  color: #909090 !important;
  margin-bottom: 10px !important;
}
#username,
#password {
  font-size: 14px !important;
  padding: 12px 15px !important;
}
.rep-icon-login {
  width: 80px;
}
/* .rep-icon-login img {
  width: 100px;
} */
.back-btn-pwd:hover{
    color: #00CCFE !important;
  }

  .verify-option {
  cursor: pointer;
}

.custom-radio {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.custom-radio input[type="radio"] {
  cursor: pointer;
  margin-right: 8px;
}
</style>
